export default __webpack_public_path__ + "static/media/hero.135e14d1.png";